// extracted by mini-css-extract-plugin
export default {"component-eyebrow":"Eyebrow-module_component-eyebrow_AIV95","componentEyebrow":"Eyebrow-module_component-eyebrow_AIV95"};